import SanityClient from "@sanity/client";

export const client = SanityClient({
  projectId: "3glo739j",
  dataset: "production",
  apiVersion: "2023-01-11",
  useCdn: true,
});
